import { call, put, select } from "redux-saga/effects";

import actions from "@/actions";

import saveAndPublishLightGroupSettings from "./save-and-publish-light-group-settings";

/**
 * Saves and publishes settings for all light groups sequentially, stopping on failure.
 *
 * @yields Calls save and publish for each light group sequentially.
 */
function* publishAllLightGroupSettings() {
    const lightGroups = yield select(({ map }) => map.general.lightGroups);

    let settings = yield select(({ map }) => map.general.lightGroupSettings);
    settings = Object.values(settings).filter((s) =>
        lightGroups.some((g) => g.groupID === s.groupID),
    );

    const numSettings = settings.length;

    for (let i = 0; i < numSettings; i++) {
        const s = settings[i];

        const progress = {
            current: i + 1,
            total: numSettings,
        };

        yield put(actions.map.general.setLightGroupSettingsProgress(progress));
        yield put(actions.map.general.setPendingLightGroupSettings(s));
        yield call(saveAndPublishLightGroupSettings);

        const status = yield select(
            ({ map }) => map.general.lightGroupSettingsStatus,
        );

        if (!status.success) {
            break;
        }
    }
}

export default publishAllLightGroupSettings;
